import React from 'react';
import { useEffect } from 'react';
import { useState } from 'react';
import { Query } from 'react-apollo';
import { Flex, Heading, Text } from 'rebass';
import ReactTable from 'react-table-v6';
import 'react-table-v6/react-table.css';
import gql from 'graphql-tag';

const GET_DEPARTMENTS_LIST = gql`
  query getRegionsList {
    getRegionsList {
      id
      label
      value
      level
      canBookNutritionist
      canBookAsync
      canBookPeriMenopause
      canBookPostMenopause
      canBookWeightLoss
    }
  }
`;

const DepartmentsList = ({ departments }) => {
  const cols = [
    {
      Header: 'Name',
      accessor: 'label',
      Cell: (row) => {
        return <div title={row.original.label}>{row.original.label}</div>;
      },
    },
    {
      Header: 'Abbreviation',
      accessor: 'value',
      Cell: (row) => {
        return <div title={row.original.value}>{row.original.value}</div>;
      },
    },
    {
      Header: 'Department Id',
      accessor: 'id',
      Cell: (row) => {
        if (!row.original.id || row.original.id === '-1') return <div />;
        return (
          <div
            style={{
              textAlign: 'center',
            }}
          >
            {row.original.id}
          </div>
        );
      },
    },
    {
      Header: 'Level',
      accessor: 'level',
      Cell: (row) => {
        if (!row.original.id || row.original.id === '-1') return <div />;
        return (
          <div
            style={{
              textAlign: 'center',
              color: row.original.level === 'full' ? 'green' : row.original.level === 'none' ? 'red' : 'orange',
            }}
          >
            {row.original.level}
          </div>
        );
      },
    },
    {
      Header: 'Nutritionist',
      accessor: 'canBookNutritionist',
      Cell: (row) => {
        return (
          <div
            style={{
              textAlign: 'center',
              color: row.original.canBookNutritionist ? 'green' : 'red',
            }}
          >
            {row.original.canBookNutritionist ? '✓' : 'x'}
          </div>
        );
      },
    },
    {
      Header: 'Peri menopause',
      accessor: 'canBookPeriMenopause',
      Cell: (row) => {
        return (
          <div
            style={{
              textAlign: 'center',
              color: row.original.canBookPeriMenopause ? 'green' : 'red',
            }}
          >
            {row.original.canBookPeriMenopause ? '✓' : 'x'}
          </div>
        );
      },
    },
    {
      Header: 'Post menopause',
      accessor: 'canBookPostMenopause',
      Cell: (row) => {
        return (
          <div
            style={{
              textAlign: 'center',
              color: row.original.canBookPostMenopause ? 'green' : 'red',
            }}
          >
            {row.original.canBookPostMenopause ? '✓' : 'x'}
          </div>
        );
      },
    },
    {
      Header: 'Weightloss',
      accessor: 'canBookWeightLoss',
      Cell: (row) => {
        return (
          <div
            style={{
              textAlign: 'center',
              color: row.original.canBookWeightLoss ? 'green' : 'red',
            }}
          >
            {row.original.canBookWeightLoss ? '✓' : 'x'}
          </div>
        );
      },
    },
  ];

  return (
    <ReactTable
      data={departments}
      columns={cols}
      defaultPageSize={departments && departments.length > 3 ? departments.length : 3}
      pageSize={departments && departments.length > 3 ? departments.length : 3}
      getProps={() => ({ someFunc: (id) => alert('clicked ' + id) })}
      showPagination={false}
      // showPagination={
      //   data.adminGetMobileCourseScreens &&
      //   data.adminGetMobileCourseScreens.length > 5
      // }
    />
  );
};

export const AdminDepartments = () => {
  return (
    <Flex flexDirection={'column'} p={4}>
      <Heading mb={4}>Departments list</Heading>
      <Query query={GET_DEPARTMENTS_LIST}>
        {({ data: dataLabOrders, loading: loadingLabOrders }) => {
          if (!dataLabOrders || !dataLabOrders.getRegionsList || dataLabOrders.getRegionsList.length < 1) {
            return (
              <Text style={{ opacity: 0.75 }} textAlign={'center'}>
                Loading...
              </Text>
            );
          }

          return (
            <>
              <DepartmentsList departments={dataLabOrders.getRegionsList} />
            </>
          );
        }}
      </Query>
    </Flex>
  );
};
